
<div class="flxClmn bs-enabled animated fadeIn">

	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Threat Events</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Investigate and act on detected threats across your collaboration environment</span>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn">

		<!-- View toggle -->
		<div class="flxRow hSpace1" style="margin-bottom: 15px; z-index: 50;">
			<btn-c variant="{{selectedViewType === viewTypes.timeline ? '' : 'outlined'}}"
				   [isDisabled]="loadingInProcess"
				   (action)="changeViewType(viewTypes.timeline)">
				Show Timeline
			</btn-c>
			<btn-c variant="{{selectedViewType === viewTypes.list ? '' : 'outlined'}}"
				   [isDisabled]="loadingInProcess"
				   (action)="changeViewType(viewTypes.list)">
				Show List
			</btn-c>
			<div class="vertical-separator" style="align-self: stretch; margin: 0 20px; border-color: lightgrey;"
				 *ngIf="selectedViewType === viewTypes.timeline"></div>
			<app-dropdown-c style="width: 300px;"
							[isDisabled]="!usersInEventsList"
				*ngIf="selectedViewType === viewTypes.timeline"
				[text]="viewAllUsers ? 'All Users' : _.map(_.filter(usersInEventsList, 'selected'), 'displayName').join(', ') || 'Select a user'"
				(click)="clearSearchUser();">
				<li (click)="selectViewUser('all'); $event.stopPropagation()">
					<checkbox (click)="$event.preventDefault();" [model]="viewAllUsers">All Users</checkbox>
				</li>
				<li class="static-item pt-2 pb-3" style="min-height: 0;" (click)="$event.stopPropagation()">
					<div class="search-box flxRow" style="position: relative;">
						<input type="search" class="w-100"
							   [(ngModel)]="searchUserTxt"
							   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
							   (keyup)="searchUser(searchUserTxt);"
							   placeholder="Search user">
						<a class="closeRed animated fadeIn"
						   (click)="clearSearchUser();"
						   *ngIf="searchUserTxt"
						   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
							<i class="zmdi zmdi-close"></i>
						</a>
					</div>
				</li>
				<virtual-scroller #userScroll
					[ngStyle]="{'height': usersInEventsList?.length * 37 + 'px'}"
					style="max-height: 250px;"
					[items]="usersInEventsList"
					[scrollAnimationTime]="0"
					[enableUnequalChildrenSizes]="true">
					<li *ngFor="let user of userScroll.viewPortItems"
						(click)="selectViewUser(user); $event.stopPropagation();" [hidden]="user.hide">
						<checkbox class="ellipsis" style="font-size: 13px;" [model]="user.selected" (click)="$event.preventDefault();">
							{{user.displayName || ''}}
						</checkbox>
					</li>
				</virtual-scroller>
			</app-dropdown-c>
			<div class="vertical-separator" style="align-self: stretch; margin: 0 20px; border-color: lightgrey;"
				 *ngIf="selectedViewType === viewTypes.timeline"></div>
			<div class="flex-row gap-2 align-items-center" *ngIf="selectedViewType === viewTypes.timeline">
				<span>Filter by Severity:</span>
				<div class="flxRow hSpace05 align-items-center">
					<span *ngFor="let severity of ['critical', 'high', 'medium', 'low']"
						  class="sev-badge"
						  [ngClass]="severityClass(severity)"
						  [style.opacity]="selectedSeverities.includes(severity) ? '1' : '0.65'"
						  (click)="selectViewSeverity(severity)"
						  style="cursor: pointer; text-transform: capitalize;">
						{{severity}}
					</span>
				</div>
			</div>
		</div>

		<!-- VIEW: list -->
		<div class="flxClmn f-1-0 animated fadeIn" style="overflow: auto;" *ngIf="selectedViewType === viewTypes.list">
			<trustifi-table-c #eventsTable
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="eventsList"
				[headers]="[
					{text: 'Created', sortKey: 'time', width: '150px'},
					{text: 'Type', sortKey: 'type'},
					{text: 'Source', sortKey: 'resource_type', width: '130px'},
					{text: 'User', sortKey: 'user'},
					{text: 'Severity', sortKey: 'severity', width: '100px'},
					{text: 'Status', sortKey: 'status', width: '150px'},
				]"
				[cellsPrototype]="[
					{textKey: 'time', textType: 'dateAndTime'},
					{html: 'typeCell'},
					{html: 'resourceTypeCell'},
					{textKey: 'user'},
					{html: 'severityCell'},
					{html: 'statusCell'},
				]"
				[subRowOptions]="{recursionKey: 'children', allowActions: true}"
				[bulkActions] = "{
					enable: true,
					selectBulkActionCb:	selectMultipleAction,
					initBulkActionsFunction: showMultipleActions,
				}"
				[cellActions]="{
					enable: true,
					selectItemActionCb: selectAction,
					initActionsFunction: showEventActions,
				}"
				[filterData]="filterData"
				(searchFunction)="searchEvents($event.searchTerm, $event.activeFilters)"
				[options]="{
					exportToCsvFunction: exportToCsv,
					loadingTableFlag: loadingInProcess,
					refreshFunction: getCollaborationEvents,
					itemsNameSingular: 'event',
					defaultSortKey: '-time',
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<span *ngIf="cellId === 'typeCell'" [tooltip]="item.description + (item.asset_id?.info?.rule_name ?  ': ' + item.asset_id?.info?.rule_name : '')" placement="top"
						  [style.cursor]="item._isAggregated ? 'pointer' : 'default'"
						  [ngStyle]="{'padding-left': item.depthLevel ? 15 + item.depthLevel * 15 + 'px' : ''}"
						  (click)="item._isAggregated && toggleExpandItem(item, $event, eventsTable)">
						<i *ngIf="item._isAggregated" class="far fa-chevron-right"
						   style="color: royalblue; transition: transform 0.15s ease-out; padding-right: 5px; font-size: 11px;"
						   [ngStyle]="{'transform': item.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'}"></i>
						<span *ngIf="item._isAggregated" class="group-count-badge me-1" [ngStyle]="{'background': eventTypeDic[item.event_type]?.color}">{{item.count}}</span>
						<span style="text-decoration: underline 1px dashed darkgray; text-underline-offset: 2px;">
							{{item.type}}
						</span>
					</span>
					<span *ngIf="cellId === 'resourceTypeCell'">
					<span class="resource-type-chip">
						<i class="far" [ngClass]="{
							'fa-hashtag': item.resource_type === 'channel',
							'fa-comments': item.resource_type === 'chat',
							'fa-video': item.resource_type === 'meeting',
							'fa-globe': item.resource_type === 'site',
							'fa-cloud': item.resource_type === 'OneDrive',
							'fa-users': item.resource_type === 'team'
						}"></i>
						{{item.resource_type}}
					</span>
					<span class="resource-type-chip" *ngIf="item.resource_sub_type === 'site'">
						<i class="far fa-globe"></i>
						site
					</span>
					<span class="resource-type-chip" *ngIf="item.resource_sub_type === 'channel'">
						<i class="far fa-hashtag"></i>
						channel
					</span>
				</span>

					<span *ngIf="cellId === 'severityCell'">
						<span class="sev-badge" [ngClass]="severityClass(item.severity)">{{item.severity}}</span>
					</span>
					<span *ngIf="cellId === 'statusCell'">
						<span class="status-chip" [ngClass]="statusClass(item.status)">
							<i class="far fa-check-circle" *ngIf="item.status === 'resolved'"></i>
							<i class="far fa-clock" *ngIf="item.status === 'pending'"></i>
							<i class="far fa-minus-circle" *ngIf="item.status === 'safe'"></i>
							{{statusLabel(item.status)}}
						</span>
					</span>
				</ng-template>
			</trustifi-table-c>
		</div>

		<!-- VIEW: timeline -->
		<div class="flxClmn f-1-0 animated fadeIn bs-enabled" #timelineContainer style="overflow: auto; background: #fbfbfb;" *ngIf="selectedViewType === viewTypes.timeline">
			<div class="d-flex centralize f-1-0" style="flex-grow:1; display: flex; background: white;" *ngIf="loadingInProcess">
				<loader height="100" width="100" style="opacity: 0.8;"></loader>
			</div>

			<div class="flex-column" style="flex: 1 0; padding: calc((20px + 3vw)/2) calc((15px + 4vw)/2);" *ngIf="!loadingInProcess">
				<virtual-scroller class="f-1-0" #scroll *ngIf="flatEventsByDate?.length"
					[items]="flatEventsByDate" [scrollAnimationTime]="0" [parentScroll]="timelineContainer" [enableUnequalChildrenSizes]="true">
					<ng-container *ngFor="let item of scroll.viewPortItems; trackBy: gs.trackByIndex">

						<!--Date label-->
						<div style="margin: 15px 0 10px 27px;" *ngIf="item.viewType === 'date'">
							<span style="background: white; padding: 5px 15px; border: solid 1px #e3e3e3; border-radius: 50px; font-weight: 500; align-self: flex-start;">
								{{item.date | date: 'MM/dd/yyyy'}}
							</span>
						</div>

						<!--Aggregated group card-->
						<div class="flxRow" style="max-width: 1200px;" *ngIf="item.viewType === 'group'">
							<div style="flex-shrink: 0;">
								<span style="font-weight: 500; white-space: nowrap; margin-top: 18px; display: block;">{{item.time | date: 'HH:mm'}}</span>
							</div>
							<div style="position: relative; padding: 0 2vw;">
								<div class="group-timeline-dot" [ngStyle]="{'border-color': colorForEvent(item.severity)}"></div>
								<div [ngStyle]="{'height': item.isLastInDate ? '30px' : 'calc(100% - 4px)'}" style="border-left: dotted 4px #e3e3e3;"></div>
							</div>

							<div style="flex: 1 0; padding-bottom: 20px;">
								<div class="group-card flex-column gap-3" style="padding: 15px 25px; box-shadow: 0 3px 5px rgba(0,0,0,0.13);">
									<div class="flxRow-between" style="align-items: center;">
										<div class="flxClmn vSpace1">
											<div class="flxRow align-items-center gap-2" style="cursor: pointer;" (click)="toggleGroup(item)">
												<i class="far group-chevron" [ngClass]="item.isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
												   style="font-size: 12px; color: #64748b; width: 14px;"></i>
												<span>
													<span style="font-weight: bold;">{{item.user}}</span>
													<span *ngIf="item.user"> &mdash; </span>
													<span class="group-count-badge" [ngStyle]="{'background': eventTypeDic[item.event_type]?.color}">{{item.count}}</span>
													<span [ngStyle]="{'color': eventTypeDic[item.event_type]?.color}" style="font-weight: 500;"> {{item.type}} events</span>
													<span *ngIf="item.resourceNames?.length"> across </span>
													<b *ngIf="item.resourceNames?.length">{{item.resourceNames.join(', ')}}</b>
													<span *ngIf="item.resourceNames?.length > 3">...</span>
												</span>
											</div>
											<span *ngIf="item.description" class="text-muted" style="margin-top: 2px; margin-left: 22px;">
												{{item.description}}
											</span>

											<div class="flxRow hSpace2 align-items-center text-muted" style="margin-top: 6px; margin-left: 22px; flex-wrap: wrap; gap: 8px;">
												<span>
													<i class="far fa-clock" style="width: 14px;"></i>
													{{item.timeRange.start | date: 'HH:mm'}} &mdash; {{item.timeRange.end | date: 'HH:mm'}}
												</span>
												<span *ngIf="item.totalFiles">
													<i class="far fa-file" style="width: 14px;"></i>
													{{item.totalFiles}} file{{item.totalFiles !== 1 ? 's' : ''}}
												</span>
											</div>

											<div class="flxRow hSpace1 align-items-center" style="margin-top: 6px; margin-left: 22px; flex-wrap: wrap; gap: 8px;">
												<span class="sev-badge" [ngClass]="severityClass(item.severity)">Severity: {{item.severity}}</span>
												<span class="status-chip" [ngClass]="statusClass(item.status)">
													<i class="far fa-check-circle" *ngIf="item.status === 'resolved'"></i>
													<i class="far fa-clock" *ngIf="item.status === 'pending'"></i>
													<i class="far fa-minus-circle" *ngIf="item.status === 'safe'"></i>
													{{statusLabel(item.status)}}
												</span>
											</div>
										</div>

										<div class="flxClmn gap-1">
											<app-dropdown-c text="Actions" style="flex-shrink: 0; width: 160px;">
												<li (click)="openEvent(item)">View Details</li>
												<li *ngIf="hasChildrenPending(item)" (click)="markResolved(item.children)">Mark All Resolved</li>
												<li (click)="deleteEvents(item.children)">Delete All</li>
											</app-dropdown-c>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!--Group child event (indented)-->
						<div class="flxRow" style="max-width: 1200px;" *ngIf="item.viewType === 'groupChild'">
							<div style="flex-shrink: 0;">
								<span style="font-weight: 500; white-space: nowrap; margin-top: 18px; display: block; visibility: hidden;">00:00</span>
							</div>
							<div style="position: relative; padding: 0 2vw;">
								<div style="position: absolute; top: 18px; left: 50%; transform: translateX(-50%); z-index: 50; border-radius: 50px; background: #cbd5e1; height: 10px; width: 10px;"></div>
								<div [ngStyle]="{'height': item.isLastInDate ? '30px' : 'calc(100% - 4px)'}" style="border-left: dotted 4px #e2e8f0;"></div>
							</div>

							<div class="group-child" style="flex: 1 0; padding-bottom: 10px;">
								<div class="flex-column gap-2" style="padding: 12px 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.08); background: white; border-left: 3px solid #e2e8f0;">
									<div class="flxRow-between" style="align-items: center;">
										<div class="flxClmn vSpace1">
											<span style="font-size: 13px;">
												<span [ngStyle]="{'color': eventTypeDic[item.event_type]?.color}" style="font-weight: 500;">{{item.type}}</span>
												<span *ngIf="item.resourceName"> in <b>{{item.resourceName}}</b></span>
												<span style="color: #94a3b8; margin-left: 8px;">{{item.time | date: 'HH:mm'}}</span>
											</span>
											<span *ngIf="item.file" style="color: #475569; font-size: 12px; margin-top: 2px;">
												<i class="far fa-file" style="width: 16px; text-align: center;"></i> {{item.file}}
											</span>
											<span *ngIf="item.details?.member" style="color: #475569; font-size: 12px; margin-top: 2px;">
												<i class="far fa-user" style="width: 16px; text-align: center;"></i> {{item.details.member}}
											</span>
											<div class="flxRow hSpace1 align-items-center" style="margin-top: 4px; gap: 6px;">
												<span class="sev-badge" [ngClass]="severityClass(item.severity)" style="font-size: 11px;">Severity: {{item.severity}}</span>
												<span class="status-chip" [ngClass]="statusClass(item.status)" style="font-size: 11px;">{{statusLabel(item.status)}}</span>
											</div>
										</div>
										<app-dropdown-c text="Actions" style="flex-shrink: 0; width: 160px;">
											<li (click)="openEvent(item)">View Details</li>
											<li *ngIf="item.status === 'pending'" (click)="markResolved([item])">Mark Resolved</li>
											<li *ngIf="item.status === 'pending'" (click)="markSafe(item)">Allow & Ignore</li>
											<li (click)="selectAction(item, 'Delete')">Delete</li>
										</app-dropdown-c>
									</div>
								</div>
							</div>
						</div>

						<!--Single event item-->
						<div class="flxRow" style="max-width: 1200px;" *ngIf="item.viewType === 'event'">
							<div style="flex-shrink: 0;">
								<span style="font-weight: 500; white-space: nowrap; margin-top: 18px; display: block;">{{item.time | date: 'HH:mm'}}</span>
							</div>
							<div style="position: relative; padding: 0 2vw;">
								<div style="position: absolute; top: 15px; left: 50%; transform: translateX(-50%); z-index: 50; border-radius: 50px; border: solid 6px; background: hsl(var(--bs-primary-h, 220), 100%, 95%); height: 23px; width: 23px;"
									 [ngStyle]="{'border-color': colorForEvent(item.severity)}"></div>
								<div [ngStyle]="{'height': item.isLastInDate ? '30px' : 'calc(100% - 4px)'}" style="border-left: dotted 4px #e3e3e3;"></div>
							</div>

							<div style="flex: 1 0; padding-bottom: 20px;">
								<div class="flex-column gap-4" style="padding: 15px 25px; box-shadow: 0 3px 5px rgba(0,0,0,0.13); background: white;">
									<!--reviewer action history-->
									<div class="flex-column gap-2" *ngIf="item.reviewer_actions?.length">
										<div style="--bs-bg-opacity: 0.065; --bs-border-opacity: 0.5; align-self: flex-start; min-width: 75%;"
											 *ngFor="let action of item.reviewer_actions"
											 class="flex-row align-items-center bg-{{reviewerActionsDic[action.action]?.color || 'secondary'}} border border-{{reviewerActionsDic[action.action]?.color || 'secondary'}} gap-2 p-2 px-3 text-{{reviewerActionsDic[action.action]?.color || 'secondary'}}">
											<i [ngClass]="reviewerActionsDic[action.action]?.icon || 'far fa-info'"></i>
											<span>
												<span class="fw-500">{{reviewerActionsDic[action.action]?.display || action.action}}</span>
												| by: {{action.reviewer}}. {{action.created | date:'MM/dd/yyyy HH:mm'}}
											</span>
										</div>
									</div>

									<!--event content-->
									<div class="flxRow-between" style="align-items: center;">
										<div class="flxClmn vSpace1">
											<span>
												<span style="font-weight: bold;">{{item.user}}</span>
												<span *ngIf="item.user"> &mdash; </span>
												<span [ngStyle]="{'color': eventTypeDic[item.event_type]?.color}" style="font-weight: 500;">{{item.type}}</span>
												<ng-container *ngIf="(item.resourceName || item.resource_type) && item.resource_type !== 'Unknown'">
													<span> in </span>
													<i class="far pe-1" style="font-size: 12px;"
													   *ngIf="item.resource_type !== 'OneDrive'"
													   [ngClass]="{
													   'fa-hashtag': item.resource_type === 'channel',
													   'fa-comments': item.resource_type === 'chat',
													   'fa-video': item.resource_type === 'meeting',
													   'fa-globe': item.resource_type === 'site'}">
													</i>
													<b>{{item.resourceName || item.resource_type}}{{item.resource_type === 'OneDrive' ? ' (OneDrive)' : ''}}</b>
												</ng-container>
											</span>
											<span class="text-muted" *ngIf="item.description" style="margin-top: 2px;">
												{{item.description}}
											</span>
											<br/>
											<table class="simpleDataTableShrink" style="table-layout: fixed; align-self: flex-start;" *ngIf="item.file || item.url || item.details?.member">
												<tr *ngIf="item.file">
													<td><b>File:</b></td>
													<td><span>{{item.file}}</span></td>
												</tr>
												<tr *ngIf="item.asset_id?.info?.file_path">
													<td><b>Path:</b></td>
													<td><span>{{item.asset_id?.info?.file_path}}</span></td>
												</tr>
												<tr *ngIf="item.url">
													<td><b>URL:</b></td>
													<td><span style="word-break: break-all;">{{item.url}}</span></td>
												</tr>
												<tr *ngIf="item.details?.member">
													<td><b>{{item.event_type === 'external_member_added' ? 'New member:' : 'Removed member:'}}</b></td>
													<td><span>{{item.details.member}}</span></td>
												</tr>
												<tr *ngIf="item.asset_id?.permissions?.link?.scope">
													<td><b>Permission:</b></td>
													<td>
														<span [ngStyle]="{'color': item.asset_id.permissions.link.scope === 'anonymous' ? 'darkred' : 'inherit'}">
															{{item.asset_id.permissions.link.scope | titlecase}}
														</span>
														<i style="font-weight: 400;" class="far fa-question-circle" [tooltip]="linkScopeTooltips[item.asset_id.permissions.link.scope]" placement="right"></i>
													</td>
												</tr>
											</table>

											<div class="flxRow hSpace1 align-items-center" style="margin-top: 4px; flex-wrap: wrap; gap: 8px;">
												<span class="sev-badge" [ngClass]="severityClass(item.severity)">Severity: {{item.severity}}</span>
												<span class="status-chip" [ngClass]="statusClass(item.status)">
													<i class="far fa-check-circle" *ngIf="item.status === 'resolved'"></i>
													<i class="far fa-clock" *ngIf="item.status === 'pending'"></i>
													<i class="far fa-minus-circle" *ngIf="item.status === 'safe'"></i>
													{{statusLabel(item.status)}}
												</span>
											</div>
										</div>

										<div class="flxClmn gap-1">
											<app-dropdown-c text="Actions" style="flex-shrink: 0; width: 160px;">
												<li (click)="openEvent(item)">View Details</li>
												<li *ngIf="item.status === 'pending'" (click)="markResolved([item])">Mark Resolved</li>
												<li *ngIf="item.status === 'pending'" (click)="markSafe(item)">Allow & Ignore</li>
												<li (click)="selectAction(item, 'Delete')">Delete</li>
											</app-dropdown-c>
										</div>
									</div>
								</div>
							</div>
						</div>

					</ng-container>
				</virtual-scroller>

				<div *ngIf="!flatEventsByDate?.length && !loadingInProcess" style="color: #94a3b8; font-size: 13px; text-align: center; padding: 40px;">
					<i class="far fa-shield-check" style="font-size: 24px; display: block; margin-bottom: 8px;"></i>
					No threat events found.
				</div>
			</div>
		</div>

	</div>
</div>

<popup-c *ngIf="eventDetailsPopup?.show"
		 head="Threat Event Details"
		 class="bs-enabled"
		 width="1600px"
		 (closeCb)="eventDetailsPopup = previousEventDetailsPopup || null; previousEventDetailsPopup = null;"
		 size="large">

	<div class="f-1-0 w100 flxClmn gap-2">
		<!-- Event description banner -->
		<div *ngIf="eventDetailsPopup.eventObj.description" class="flxRow align-items-center gap-2"
			 style="padding: 12px 20px; margin: 0 15px 5px; background: #fef3c7; border-left: 4px solid #f59e0b; border-radius: 4px; font-size: 13px; color: #92400e;">
			<i class="far fa-exclamation-triangle" style="flex-shrink: 0;"></i>
			<span>{{eventDetailsPopup.eventObj.description}}</span>
		</div>

		<!-- Aggregated group summary -->
		<div *ngIf="eventDetailsPopup.eventObj._isAggregated" class="flxRow" style="padding: 0 15px; flex-wrap: wrap; font-size: 14px;">
			<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-user text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">User: </b>
				<span>{{eventDetailsPopup.eventObj.user}}</span>
			</div>
			<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-exclamation-circle text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">Highest Severity: </b>
				<span class="sev-badge" [ngClass]="severityClass(eventDetailsPopup.eventObj.severity)">{{eventDetailsPopup.eventObj.severity}}</span>
			</div>
			<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-clock text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">Time Range: </b>
				<span>{{eventDetailsPopup.eventObj.timeRange.start | date: 'MM/dd/yyyy HH:mm'}} &mdash; {{eventDetailsPopup.eventObj.timeRange.end | date: 'HH:mm'}}</span>
			</div>
			<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-cube text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">Resources: </b>
				<span>{{eventDetailsPopup.eventObj.resourceNames?.join(', ') || 'N/A'}}</span>
			</div>
			<div *ngIf="eventDetailsPopup.eventObj.totalFiles" class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-file text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">Files Affected: </b>
				<span>{{eventDetailsPopup.eventObj.totalFiles}}</span>
			</div>
			<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
				<i class="far fa-info-circle text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
				<b style="white-space: nowrap;">Status: </b>
				<span class="status-chip" [ngClass]="statusClass(eventDetailsPopup.eventObj.status)">{{statusLabel(eventDetailsPopup.eventObj.status)}}</span>
			</div>
		</div>

		<!--Aggregated children table-->
		<trustifi-table-c
			*ngIf="eventDetailsPopup.eventObj._isAggregated"
			class="trustifi-table m-2" style="flex: 1 0; z-index: 5; min-height: 300px;"
			[list]="eventDetailsPopup.eventObj.children"
			[headers]="[
				{text: 'Time', sortKey: 'time', width: '150px'},
				{text: 'Resource', sortKey: 'resourceName'},
				{text: 'File'},
				{text: 'Details'},
				{text: 'Severity', sortKey: 'severity', width: '100px'},
				{text: 'Status', sortKey: 'status', width: '130px'},
			]"
			[cellsPrototype]="[
				{textKey: 'time', textType: 'dateAndTime'},
				{textKey: 'resourceName'},
				{html: 'fileCell'},
				{html: 'groupDetailsCell'},
				{html: 'groupSevCell'},
				{html: 'groupStatusCell'},
			]"
			[cellActions]="{
				enable: true,
				selectItemActionCb: selectAction,
				initActionsFunction: showEventActions,
			}"
			[options]="{
				itemsNameSingular: 'event',
				defaultSortKey: '-time',
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				    <span *ngIf="cellId === 'fileCell'" class="flex-column">
						<span>{{item.file}}</span>
						<span *ngIf="item.asset_id?.size" style="font-size: 11px; color: #64748b;">{{item.asset_id.size | FormatBytes}}</span>
					</span>
					<span *ngIf="cellId === 'groupSevCell'" >
						<span class="sev-badge" [ngClass]="severityClass(item.severity)">{{item.severity}}</span>
					</span>
					<span *ngIf="cellId === 'groupStatusCell'" >
						<span class="status-chip" [ngClass]="statusClass(item.status)">{{statusLabel(item.status)}}</span>
					</span>
					<span *ngIf="cellId === 'groupDetailsCell'" >
						<!-- CC: member events -->
						<span *ngIf="eventDetailsPopup.eventObj.event_type === 'external_member_added' || eventDetailsPopup.eventObj.event_type === 'external_member_removed'" >
							<i class="far fa-user text-muted" style="width: 16px; text-align: center;"></i>
							{{item.details?.member}}
						</span>
						<!-- CC: permission events -->
						<span *ngIf="eventDetailsPopup.eventObj.event_type === 'permission_change' || eventDetailsPopup.eventObj.event_type === 'sensitive_data_shared_externally'" >
							<span class="permission-scope-chip" [ngClass]="{
								'scope-anonymous': item.asset_id?.permissions?.link?.scope === 'anonymous',
								'scope-external': item.asset_id?.permissions?.link?.scope === 'external',
								'scope-organization': item.asset_id?.permissions?.link?.scope === 'organization',
								'scope-users': item.asset_id?.permissions?.link?.scope === 'users'
							}">{{item.asset_id?.permissions?.link?.scope | titlecase}}</span>
						</span>
						<!-- CC: malicious/phishing events -->
						<span *ngIf="eventDetailsPopup.eventObj.event_type === 'malicious_content_detected' || eventDetailsPopup.eventObj.event_type === 'phishing_detected'"
							  style="font-size: 11px; word-break: break-all;">
							{{item.asset_id?.malicious_info?.sub_status?.[0]?.sub_status}}
						</span>
						<!-- CC: DLP / compliance events -->
						<span *ngIf="eventDetailsPopup.eventObj.event_type === 'dlp_violation_detected' || eventDetailsPopup.eventObj.event_type === 'compliance_violation'" >
							<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="item.asset_id?.sensitivity_info?.sensitive_types?.length">
								<span class="detection-tag detection-tag-dlp" *ngFor="let type of item.asset_id?.sensitivity_info.sensitive_types">
									{{type.sensitive_type}}
								</span>
							</div>
						</span>
					</span>
			</ng-template>
			<div tableButtons>
				<h6>Events in this group</h6>
			</div>
		</trustifi-table-c>

		<ng-container *ngIf="!eventDetailsPopup.eventObj._isAggregated">
			<div class="flxRow" style="padding: 0 15px; flex-wrap: wrap; font-size: 14px;">
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="fas fa-shield-alt text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Detection: </b>
					<span>{{eventDetailsPopup.eventObj.type}} in {{eventDetailsPopup.eventObj.resource_type}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-user text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">User: </b>
					<span>{{eventDetailsPopup.eventObj.user || eventDetailsPopup.eventObj.resource_id?.name}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-exclamation-circle text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Severity: </b>
					<span class="sev-badge" [ngClass]="severityClass(eventDetailsPopup.eventObj.severity)">
						{{eventDetailsPopup.eventObj.severity}}
					</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-clock text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Detected: </b>
					<span>{{eventDetailsPopup.eventObj.time | date: 'MM/dd/yyyy HH:mm'}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-info-circle text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Status: </b>
					<span class="status-chip" [ngClass]="statusClass(eventDetailsPopup.eventObj.status)">
						{{statusLabel(eventDetailsPopup.eventObj.status)}}
					</span>
				</div>
				<div *ngIf="eventDetailsPopup.eventObj.asset_id?.permissions?.link?.scope" class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-user-check text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Permission: </b>
					<div class="flex-row gap-1">
						<div class="flex-row gap-1 align-items-center text-danger cursor-default" style="width: fit-content;"
							 *ngIf="eventDetailsPopup.eventObj.asset_id?.permissions?.link?.scope=== 'anonymous'">
							<i class="far fa-exclamation-triangle"></i>
							<span class="fw-500">Anonymous</span>
						</div>
						<span *ngIf="eventDetailsPopup.eventObj.asset_id?.permissions?.link?.scope!== 'anonymous'">
								{{eventDetailsPopup.eventObj.asset_id?.permissions?.link?.scope}}
							</span>
						<i style="font-weight: 400;" class="far fa-question-circle" [tooltip]="linkScopeTooltips[eventDetailsPopup.eventObj.asset_id?.permissions?.link?.scope]" placement="right"></i>
					</div>
				</div>
				<div *ngIf="eventDetailsPopup.eventObj.asset_id?.permissions?.link?.webUrl" class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline">
					<i class="far fa-share-square text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Shared link: </b>
					<div class="flex-row gap-1">
						<a class="blue-link text-decoration-underline break-word" [href]="eventDetailsPopup.eventObj.asset_id?.permissions?.link.webUrl" target="_blank">
							{{eventDetailsPopup.eventObj.asset_id?.permissions?.link.webUrl}}
						</a>
					</div>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.resourceName">
					<i class="far fa-cube text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Resource: </b>
					<span>{{eventDetailsPopup.eventObj.resourceName}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.file">
					<i class="far fa-file text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">File: </b>
					<span>{{eventDetailsPopup.eventObj.file}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.asset_id?.info?.file_path">
					<i class="far fa-folder-open text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Path: </b>
					<div class="flex-row gap-2">
						<span>{{eventDetailsPopup.eventObj.asset_id?.info?.file_path}}</span>
						<i tooltip="Copy" class="far fa-copy copy-link text-muted" style="cursor: pointer;" (click)="gs.copyToClipboard(eventDetailsPopup.eventObj.asset_id?.info?.file_path);"></i>
					</div>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.asset_id?.info?.mime_type">
					<i class="far fa-code text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">MIME type: </b>
					<span>{{eventDetailsPopup.eventObj.asset_id.info.mime_type}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.asset_id?.info?.rule_name">
					<i class="far fa-clipboard-check text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Rule name: </b>
					<span>{{eventDetailsPopup.eventObj.asset_id.info.rule_name}}</span>
				</div>
				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.url">
					<i class="far fa-link text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">URL: </b>
					<span style="word-break: break-word;">{{eventDetailsPopup.eventObj.url}}</span>
				</div>

				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.event_type === 'external_member_added'">
					<i class="far fa-user text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">New member: </b>
					<span style="word-break: break-word;">{{eventDetailsPopup.eventObj.details?.member}}</span>
				</div>

				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.event_type === 'external_member_removed'">
					<i class="far fa-user text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Removed member: </b>
					<span style="word-break: break-word;">{{eventDetailsPopup.eventObj.details?.member}}</span>
				</div>

				<div class="flxRow hSpace1 border-bottom border-light w-50 px-3 py-2 align-items-baseline"
					 *ngIf="eventDetailsPopup.eventObj.resource_id?.members?.length && (eventDetailsPopup.eventObj.event_type === 'external_member_added' || eventDetailsPopup.eventObj.event_type === 'external_member_removed')">
					<i class="far fa-user text-muted flex-shrink-0" style="width: 20px; text-align: center;"></i>
					<b style="white-space: nowrap;">Members: </b>
					<span style="word-break: break-word;">{{eventDetailsPopup.eventObj.resource_id?.members?.join(', ')}}</span>
				</div>
			</div>

			<!--reviewer action history-->
			<div class="flex-column gap-2" style="padding: 10px 20px;" *ngIf="eventDetailsPopup.eventObj.reviewer_actions?.length">
				<span style="font-weight: 600; font-size: 13px; color: #475569;">Activity Log</span>
				<div style="--bs-bg-opacity: 0.065; --bs-border-opacity: 0.5; align-self: flex-start; min-width: 60%;"
					 *ngFor="let action of eventDetailsPopup.eventObj.reviewer_actions"
					 class="flex-row align-items-center bg-{{reviewerActionsDic[action.action]?.color || 'secondary'}} border border-{{reviewerActionsDic[action.action]?.color || 'secondary'}} gap-2 p-2 px-3 text-{{reviewerActionsDic[action.action]?.color || 'secondary'}}">
					<i [ngClass]="reviewerActionsDic[action.action]?.icon || 'far fa-info'"></i>
					<span>
						<span class="fw-500">{{reviewerActionsDic[action.action]?.display || action.action}}</span>
						| by: {{action.reviewer}}. {{action.created | date:'MM/dd/yyyy HH:mm'}}
					</span>
				</div>
			</div>

			<div class="threat-protection-card flxClmn ro10 co10 f-1-0 flex-shrink-0" style="min-height: 300px;"
				 *ngIf="eventDetailsPopup.eventObj.asset_id?.sensitivity_info || eventDetailsPopup.eventObj.asset_id?.malicious_info">
				<div class="card-header flxRow-between" style="align-items: center;">
					<span class="card-title">
						Content Analysis
					</span>
				</div>

				<div class="animated fadeIn gap-3 flxClmn" style="padding: 15px; background: #f9f9f9; flex: 1 0;" *ngIf="eventDetailsPopup.eventObj.asset_id?.sensitivity_info">
					<span class="flxRow" style="align-items: center; font-size: 1.15rem; color: orangered;">
						<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
						Sensitive content detected
					</span>

					<div *ngIf="eventDetailsPopup.eventObj.asset_id?.sensitivity_info.sensitive_types?.length" class="flex-column f-1-0 gap-2 overflow-auto"
						 style="min-height: 300px;">
						<trustifi-table-c
							class="trustifi-table" style="flex: 1 0; z-index: 5;"
							[list]="eventDetailsPopup.eventObj.asset_id?.sensitivity_info.sensitive_types"
							[headers]="[
								{text: 'Type', sortKey: 'sensitive_type'},
								{text: 'Score', sortKey: 'score', width: '70px'},
								{text: 'Content'},
								{text: 'Compliance'},
							]"
							[cellsPrototype]="[
								{textKey: 'sensitive_type'},
								{textKey: 'score'},
								{html: 'contentCell'},
								{html: 'complianceCell'},
							]"
							[options]="{
								isEllipsis: false,
								itemsNameSingular: 'type',
							}"
						>
							<ng-template #customCells let-item let-cellId="cellId">
								<div *ngIf="cellId === 'contentCell'">
									<div class="px-2 py-1 border rounded-1 flex-row gap-2">
										<input class="f-1-0 border-0 p-0 h-auto" style="font-size: 12px; background: inherit;"
											   type="{{!item.showSensitiveContent ? 'password':'text'}}"
											   [ngStyle]="{'letter-spacing' : item.showSensitiveContent ? 'normal' : '2.4px'}"
											   [ngClass]="{'nofill': !item.showSensitiveContent}"
											   [ngModel]="item.content" disabled>

										<label class="hidepwd hvr-opacity" style="margin-bottom: 0; cursor: pointer; color: #676767;"
											   tooltip="{{item.showSensitiveContent ? 'Hide sensitive content' : 'Show sensitive content'}}">
											<input type="checkbox" [(ngModel)]="item.showSensitiveContent"/>
											<i class="fas fa-eye unchecked" ></i>
											<i class="fas fa-eye-slash checked"></i>
										</label>
										<i tooltip="Copy" class="far fa-copy copy-link" style="cursor: pointer; color: #676767;" (click)="gs.copyToClipboard(item.content);"></i>
									</div>
								</div>

								<div *ngIf="cellId === 'complianceCell'">
									<div class="value flex-row gap-2 justify-content-start flex-wrap">
										<span class="p-1 rounded-1 bg-dark bg-opacity-10"
											  *ngFor="let compliance of item.compliance" >
											{{compliance}}
										</span>
									</div>
								</div>
							</ng-template>

							<div tableButtons>
								<div class="flex-row p-1 rounded-1 align-items-center gap-1" style="border: 1px solid; width: 150px;"
									 [ngStyle]="eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score === 0 && {'background-color':'#32cd324d', 'border-color':'limegreen'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score < 4 && {'background-color':'#ff8c004d', 'border-color':'darkorange'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score < 5 && {'background-color':'#FF851B4d', 'border-color':'#FF851B'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score === 5 && {'background-color':'#FF41364d', 'border-color':'#FF4136' }">
									<div class="header">Sensitivity Score:</div>
									<input type="button" value="{{eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score}}"
										   [ngStyle]="eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score === 0 && {'background':'limegreen'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score < 4 && {'background':'darkorange'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score < 5 && {'background':'#FF851B'} || eventDetailsPopup.eventObj.asset_id?.sensitivity_info.score === 5 && {'background':'#FF4136'}"
										   class="redborder" style="cursor: unset; width: 25px; margin: 0; padding-top: 4px; padding-bottom: 4px; border: 0; color: white !important;"
										   tooltip="Reflects how sensitive the content found in the email is on a scale of 0 (not sensitive) to 5 (extremely sensitive)" placement="right">
								</div>
							</div>
						</trustifi-table-c>
					</div>
				</div>

				<div class="animated fadeIn gap-3 flxClmn" style="padding: 15px; background: #f9f9f9; flex: 1 0;" *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info">
					<span class="flxRow" style="align-items: center; font-size: 1.15rem; color: orangered;">
						<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
						Malicious link detected
					</span>

					<table class="w100 simpleDataTable">
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.url">
							<th style="padding: 0; border: none; width: 150px;"></th>
							<th style="padding: 0; border: none;"></th>
						</tr>
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.url">
							<td><b>URL address: </b></td>
							<td>
								<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{eventDetailsPopup.eventObj.asset_id?.malicious_info.url}}</span>
							</td>
						</tr>
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.domain">
							<td><b>Domain: </b></td>
							<td>
								<span>{{eventDetailsPopup.eventObj.asset_id?.malicious_info.domain}}</span>
								<span *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.is_black_list"> (Blocklist)</span>
							</td>
						</tr>
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.status">
							<td><b>Type: </b></td>
							<td>
								<span [ngStyle]="{'color': eventDetailsPopup.eventObj.asset_id?.malicious_info.status === 'Safe' ? 'green' : eventDetailsPopup.eventObj.asset_id?.malicious_info.status === 'Malicious' ? 'darkred' : 'inherit'}">
								  {{eventDetailsPopup.eventObj.asset_id?.malicious_info.status}}
								</span>
							</td>
						</tr>
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.sub_status && eventDetailsPopup.eventObj.asset_id?.malicious_info.sub_status.length">
							<td><b>Detection{{eventDetailsPopup.eventObj.asset_id?.malicious_info.sub_status.length > 1 ? 's' : ''}}: </b></td>
							<td>
								<div class="flxClmn vSpace1">
									<div *ngFor="let detection of eventDetailsPopup.eventObj.asset_id?.malicious_info.sub_status" class="flxRow hSpace1" style="color: darkred;">
										<i class="far fa-exclamation-triangle"></i>
										<span>{{detection.message}}</span>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="eventDetailsPopup.eventObj.asset_id?.malicious_info.malware_type">
							<td><b>Malicious link: </b></td>
							<td>
								<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{eventDetailsPopup.eventObj.asset_id?.malicious_info.malware_type}}</span>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</ng-container>

		<trustifi-table-c
			*ngIf="eventDetailsPopup.eventObj.assets?.length"
			class="trustifi-table short-action-column m-2" style="flex: 1 0; z-index: 5; min-height: 300px;"
			[list]="eventDetailsPopup.eventObj.assets"
			[headers]="[
						{text: 'Detected', sortKey: 'created', width: '100px'},
						{text: 'User', sortKey: 'user'},
						{text: 'Resource', sortKey: 'resource_id.name', width: '20%'},
						{text: 'Type', sortKey: 'asset_type', width: '90px'},
						{text: 'Category', sortKey: 'category', width: '115px'},
						{text: 'Detection Details'},
						{text: 'Access', width: '130px'},
					]"
			[cellsPrototype]="[
						{html: 'createdCell'},
						{textKey: 'user'},
						{html: 'resourceCell'},
						{html: 'typeCell'},
						{html: 'categoryCell'},
						{html: 'detectionCell'},
						{html: 'accessCell'},
					]"
			[cellActions]="{
						enable: true,
						selectItemActionCb:	selectAssetAction,
						initActionsFunction: showAssetActions,
						showInRed: {enable: true, terms: ['Delete']}
					}"
			[options]="{
						itemsNameSingular: 'asset',
						defaultSortKey: '-created',
					}"
		>
			<ng-template #customCells let-item let-cellId="cellId">

				<!--Detected date-->
				<span *ngIf="cellId === 'createdCell'"
					  style="white-space: normal; text-overflow: unset; text-align: center; display: block; max-width: min-content;">
					{{item.created | date:'MM/dd/yyyy HH:mm'}}
				</span>

				<!--Resource: name + source type chip-->
				<div class="flex-column gap-1" *ngIf="cellId === 'resourceCell'">
					<span class="ellipsis">{{item.resource_id?.name || 'N/A'}}</span>
					<div class="flex-row gap-1 align-items-center">
						<span class="resource-type-chip">
							<i class="far" [ngClass]="{
								'fa-hashtag': item.resource_id?.resource_type === 'channel',
								'fa-comments': item.resource_id?.resource_type === 'chat',
								'fa-video': item.resource_id?.resource_type === 'meeting',
								'fa-globe': item.resource_id?.resource_type === 'site',
								'fa-cloud': item.resource_id?.resource_type === 'OneDrive'
							}"></i>
							{{item.resource_id?.resource_type || 'N/A'}}
						</span>
						<span class="resource-type-chip" *ngIf="item.resource_id?.resource_sub_type && item.resource_id?.resource_sub_type !== item.resource_id?.resource_type">
							<i class="far" [ngClass]="{
								'fa-globe': item.resource_id?.resource_sub_type === 'site',
								'fa-hashtag': item.resource_id?.resource_sub_type === 'channel',
								'fa-user': item.resource_id?.resource_sub_type === 'personal'
							}"></i>
							{{item.resource_id?.resource_sub_type}}
						</span>
					</div>
				</div>

				<!--Type: file/message with icon-->
				<div class="flex-row gap-1 align-items-center" *ngIf="cellId === 'typeCell'">
					<i class="far" style="font-size: 11px; color: #64748b;" [ngClass]="{
						'fa-file-alt': item.asset_type === 'file',
						'fa-comment-alt': item.asset_type === 'message'
					}"></i>
					<span>{{item.asset_type | titlecase}}</span>
				</div>

				<!--Category: colored badge for DLP or Malicious-->
				<div *ngIf="cellId === 'categoryCell'">
					<div class="category-badge category-dlp" *ngIf="item.category === 'DLP'">
						<i class="fas fa-shield-alt"></i>
						<span>DLP</span>
						<span class="sensitivity-score-badge"
							  [ngStyle]="{'background': sensitivityScoreColor(item.sensitivity_info?.score ?? 0)}">
							{{item.sensitivity_info?.score ?? 0}}
						</span>
					</div>
					<div class="category-badge category-malicious" *ngIf="item.category === 'Malicious'">
						<i class="far fa-bug"></i>
						<span>{{item.malicious_info?.status || 'Malicious'}}</span>
					</div>
					<div class="category-badge category-rules"
						 *ngIf="item.category === 'Rule'"
						 [tooltip]="item.info?.rule_name ? 'Rule: ' + item.info?.rule_name : null">
						<i class="far fa-list"></i>
						<span style="text-decoration: underline; text-decoration-style: dotted;">Rules</span>
					</div>
				</div>

				<!--Detection Details: sensitive types or malicious sub-category-->
				<div *ngIf="cellId === 'detectionCell'" class="flex-column gap-1">
					<!--DLP details-->
					<ng-container *ngIf="item.category === 'DLP'">
						<div class="flex-row gap-1 flex-wrap justify-content-start">
							<span class="detection-tag detection-tag-dlp" *ngFor="let type of item._topSensitiveTypes">
								{{type}}
							</span>
						</div>
						<span class="opacity-50" style="font-size: 11px;" *ngIf="item.sensitivity_info.sensitive_types?.length > 3">
							+{{item.sensitivity_info.sensitive_types.length - 3}} more
						</span>
					</ng-container>

					<!--Malicious details-->
					<ng-container *ngIf="item.category === 'Malicious'">
						<div class="flex-column gap-1">
							<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="item._maliciousSubCategory?.length">
								<span class="detection-tag detection-tag-malicious" *ngFor="let msg of item._maliciousSubCategory">
									{{msg}}
								</span>
							</div>
							<span class="opacity-75 ellipsis" style="font-size: 11px;" *ngIf="item.malicious_info?.domain"
								  tooltip="{{item.malicious_info?.url}}" placement="top">
								{{item.malicious_info?.domain}}
							</span>
						</div>
					</ng-container>

					<!--DLP details-->
					<ng-container *ngIf="item.category === 'Rule'">
						<span *ngIf="item.info?.rule_name">
							Rule: {{item.info.rule_name}}
						</span>
					</ng-container>
				</div>

				<!--Access: members count + permission scope-->
				<div *ngIf="cellId === 'accessCell' && !item.is_quarantine" class="flex-column gap-1">
					<div class="flex-row gap-1 align-items-center" *ngIf="item.resource_id?.members?.length"
						 tooltip="{{item.resource_id?.members?.join('\n')}}" placement="top">
						<i class="far fa-users" style="font-size: 11px; color: #64748b;"></i>
						<span class="members-hover-link" style="font-size: 12px;">{{item.resource_id?.members?.length}} member{{item.resource_id?.members?.length !== 1 ? 's' : ''}}</span>
						<span class="external-badge" *ngIf="item.resource_id?.external_members?.length"
							  tooltip="{{item.resource_id?.external_members?.join('\n')}}" placement="top">
							{{item.resource_id?.external_members?.length}} ext
						</span>
					</div>
					<div class="flex-row gap-1 align-items-center" *ngIf="item.permissions?.link?.scope"
						 (click)="$event.stopPropagation();">
						<i class="far fa-exclamation-triangle text-warning" style="font-size: 11px;"
						   *ngIf="item.permissions?.link?.scope === 'anonymous'"
						   tooltip="This file is publicly accessible">
						</i>
						<span class="permission-scope-chip"
							  [ngClass]="{
								'scope-anonymous': item.permissions?.link?.scope === 'anonymous',
								'scope-external': item.permissions?.link?.scope === 'external',
								'scope-organization': item.permissions?.link?.scope === 'organization',
								'scope-users': item.permissions?.link?.scope === 'users'
							  }">
							{{item.permissions?.link?.scope | titlecase}}
						</span>
						<i style="font-weight: 400; font-size: 11px;" class="far fa-question-circle opacity-50"
						   [tooltip]="linkScopeTooltips[item.permissions?.link?.scope]" placement="right"></i>
					</div>
				</div>

				<div *ngIf="cellId === 'accessCell' && item.is_quarantine" style="color: red;">
					Quarantined
				</div>

			</ng-template>
			<div tableButtons>
				<h6>Assets Detected in Resource</h6>
			</div>
		</trustifi-table-c>



	</div>
</popup-c>


<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>
